import { render, staticRenderFns } from "./SettingsInvoices.vue?vue&type=template&id=157310ee"
import script from "./SettingsInvoices.vue?vue&type=script&lang=js"
export * from "./SettingsInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports